import { authAPI } from '../api/endpoints.js'

class AuthService {
  constructor() {
    this.token = localStorage.getItem('authToken')
    this.refreshToken = localStorage.getItem('refreshToken')
    this.user = JSON.parse(localStorage.getItem('user') || 'null')
  }

  async login(credentials) {
    try {
      // Usar login de usuário (tabela users) para o dashboard
      const response = await authAPI.login(credentials)
      
      if (response.success || response.token) {
        // Adaptar resposta da API
        const token = response.token || response.data?.token
        const refreshToken = response.refreshToken || response.data?.refreshToken
        const user = response.user || response.data?.user || response.data

        this.token = token
        this.refreshToken = refreshToken
        this.user = user

        localStorage.setItem('authToken', this.token)
        localStorage.setItem('refreshToken', this.refreshToken)
        localStorage.setItem('user', JSON.stringify(this.user))

        return response
      }
      
      throw new Error(response.message || 'Login failed')
    } catch (error) {
      console.error('Login error:', error)
      throw error
    }
  }

  async register(userData) {
    try {
      // Preparar dados para a API de registro
      const registerData = {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        role: 'user'
      }

      const response = await authAPI.register(registerData)
      
      if (response.success || response.token) {
        // Adaptar resposta da API
        const token = response.token || response.data?.token
        const refreshToken = response.refreshToken || response.data?.refreshToken
        const user = response.user || response.data?.user || response.data

        this.token = token
        this.refreshToken = refreshToken
        this.user = user

        localStorage.setItem('authToken', this.token)
        localStorage.setItem('refreshToken', this.refreshToken)
        localStorage.setItem('user', JSON.stringify(this.user))

        return response
      }
      
      throw new Error(response.message || 'Registration failed')
    } catch (error) {
      console.error('Registration error:', error)
      throw error
    }
  }

  async adminLogin(credentials) {
    try {
      const response = await authAPI.login(credentials)
      
      if (response.success) {
        this.token = response.data.token
        this.refreshToken = response.data.refreshToken
        this.user = response.data.user

        localStorage.setItem('authToken', this.token)
        localStorage.setItem('refreshToken', this.refreshToken)
        localStorage.setItem('user', JSON.stringify(this.user))

        return response
      }
      
      throw new Error(response.message || 'Admin login failed')
    } catch (error) {
      console.error('Admin login error:', error)
      throw error
    }
  }

  async logout() {
    try {
      if (this.token) {
        await authAPI.logout()
      }
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      this.clearAuth()
    }
  }

  clearAuth() {
    this.token = null
    this.refreshToken = null
    this.user = null
    
    localStorage.removeItem('authToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
  }

  async verifyToken() {
    if (!this.token) return false

    try {
      const response = await authAPI.verify()
      return response.success
    } catch (error) {
      console.error('Token verification failed:', error)
      this.clearAuth()
      return false
    }
  }

  async refreshAuthToken() {
    if (!this.refreshToken) {
      this.clearAuth()
      return false
    }

    try {
      const response = await authAPI.refresh()
      
      if (response.success) {
        this.token = response.data.token
        localStorage.setItem('authToken', this.token)
        return true
      }
      
      this.clearAuth()
      return false
    } catch (error) {
      console.error('Token refresh failed:', error)
      this.clearAuth()
      return false
    }
  }

  isAuthenticated() {
    return !!this.token && !!this.user
  }

  getUser() {
    return this.user
  }

  getToken() {
    return this.token
  }

  async resetPassword(email) {
    try {
      const response = await authAPI.resetPassword(email)
      return response
    } catch (error) {
      console.error('Password reset error:', error)
      throw error
    }
  }

  async confirmReset(data) {
    try {
      const response = await authAPI.confirmReset(data)
      return response
    } catch (error) {
      console.error('Password reset confirmation error:', error)
      throw error
    }
  }
}

export default new AuthService()
